import type React from 'react';
import { logo } from '../../../images/index.js';

type LogoProps = {
  readonly className?: string;
  readonly width?: string;
  readonly height?: string;
};

const Logo: React.FC<LogoProps> = ({ className, width, height }: LogoProps) => {
  if (logo) {
    return <img className={className} width={width} height={height} src={logo} />;
  }

  return null;
};

export default Logo;
